import { HiMenuAlt4 } from "react-icons/hi";
import { AiOutlineClose } from "react-icons/ai";
import logo from "../images/ethereum.png";
import { useState } from "react";

const NavItem = ({ title, classprops }) => (
  <li className={`mx-4 cursor-pointer ${classprops}`}>{title}</li>
);

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const links = [
    "https://within-the-crypto-world.netlify.app/",

    "https://metamask.io/",
  ];

  const handleClick = (item) => {
    let index = item === "Market" ? 0 : item === "Exchanges" ? 1 : 0;
    window.open(links[index], "_blank", "noopener,noreferrer");
  };

  return (
    <nav className="w-full flex md:justify-center justify-between items-center p-4">
      <h1 className="text-white mx-2 text-lg">TransportEth</h1>
      <div className="md:flex-[0.5] flex-initial justify-center items-center">
        <img src={logo} alt="logo" className="w-32 cursor-pointer" />
      </div>

      <ul className="text-white md:flex hidden list-none flex-row justify-between items-center flex-initial">
        {["Market", "Wallet"].map((item, index) => (
          <li key={item + index} className="mx-2 text-lg hover:bg-black">
            <a href={links[index]} target="_blank">
              {item}
            </a>
          </li>
        ))}
      </ul>
      <div className="flex relative">
        {toggleMenu ? (
          <AiOutlineClose
            fontSize={28}
            className="text-white md:hidden cursor-pointer"
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <HiMenuAlt4
            fontSize={28}
            className="text-white md:hidden cursor-pointer"
            onClick={() => setToggleMenu(true)}
          />
        )}
        {toggleMenu && (
          <ul
            className="z-10 fixed top-0 -right-2 p-3 w-[70vw] h-screen shadow-2xl md:hidden list-none
            flex flex-col justify-start items-end rounded-md blue-glassmorphism text-white animate-slide-in"
          >
            <li className="text-xl w-full my-2">
              <AiOutlineClose onClick={() => setToggleMenu(false)} />
            </li>
            {["Market", "Wallet"].map((item, index) => (
              <li
                key={item + index}
                className="mx-2 text-lg hover:bg-black"
                classprops="my-2 text-lg"
              >
                <a href={links[index]} target="_blank">
                  {item}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
